import { BaseModel } from "model/BaseModel";
import { BaseEditModel } from "model/BaseEditModel";
import ClassePlanoAuditoria from "./ClassePlanoAuditoria";
import RequisitoAuditoria from "../requisitoAuditoria/RequisitoAuditoria";

export default class ItemPlanoAuditoria implements BaseEditModel {

    key: string | null = null;
    id: number;
    nome: string;
    descricao: string;
    sequencial: number;
    ativo: boolean;
    requisitoAuditoria: RequisitoAuditoria;
    classePlanoAuditoria: ClassePlanoAuditoria;

    constructor(
        id = 0,
        nome = '',
        descricao = '',
        sequencial = 0,
        ativo = true,
        requisitoAuditoria = new RequisitoAuditoria(),
        classePlanoAuditoria = new ClassePlanoAuditoria()
    ) {
        this.id = id;
        this.nome = nome;
        this.descricao = descricao;
        this.sequencial = sequencial;
        this.ativo = ativo;
        this.requisitoAuditoria = requisitoAuditoria
        this.classePlanoAuditoria = classePlanoAuditoria;
    }
}
